import { withModalConditionalRender } from '@billy/design-system'

import { ModalId } from '../../../../../../../../enums/modalId'
import { useVatDeclaration } from '../../../../../../context/vatDeclarationContext'
import { VatDeclarationsChangePeriodModal as VatDeclarationsChangePeriodModalComponent } from '../../../../../VatDeclarationsChangePeriodModal'
import { VatDeclarationsDefinePayoutModal as VatDeclarationsDefinePayoutModalComponent } from '../../../../../VatDeclarationsDefinePayoutModal'
import { VatDeclarationsExportModal as VatDeclarationsExportModalComponent } from '../../../../../VatDeclarationsExportModal'
import { VatDeclarationsRegisterPeriodPaymentModal as VatDeclarationsRegisterPeriodPaymentModalComponent } from '../../../../../VatDeclarationsRegisterPeriodPaymentModal'
import { VatDeclarationsSettlePeriodModal as VatDeclarationsSettlePeriodModalComponent } from '../../../../../VatDeclarationsSettlePeriodModal'
import { VatDeclarationsVoidPeriodPaymentConfirmationModal as VatDeclarationsVoidPeriodPaymentConfirmationModalComponent } from '../../../../../VatDeclarationsVoidPeriodPaymentConfirmationModal'
import { VatDeclarationsVoidPeriodSettlementConfirmationModal as VatDeclarationsVoidPeriodSettlementConfirmationModalComponent } from '../../../../../VatDeclarationsVoidPeriodSettlementConfirmationModal'

const VatDeclarationsExportModal = withModalConditionalRender(VatDeclarationsExportModalComponent)
const VatDeclarationsRegisterPeriodPaymentModal = withModalConditionalRender(
  VatDeclarationsRegisterPeriodPaymentModalComponent,
)
const VatDeclarationsSettlePeriodModal = withModalConditionalRender(VatDeclarationsSettlePeriodModalComponent)
const VatDeclarationsVoidPeriodPaymentModal = withModalConditionalRender(
  VatDeclarationsVoidPeriodPaymentConfirmationModalComponent,
)
const VatDeclarationsVoidPeriodSettlementModal = withModalConditionalRender(
  VatDeclarationsVoidPeriodSettlementConfirmationModalComponent,
)
const VatDeclarationsChangePeriodModal = withModalConditionalRender(VatDeclarationsChangePeriodModalComponent)
const VatDeclarationsDefinePayoutModal = withModalConditionalRender(VatDeclarationsDefinePayoutModalComponent)

const vatDeclarationsExportModalId = ModalId.VatDeclarationsExportModal
const vatDeclarationsRegisterPaymentModalId = ModalId.VatDeclarationsRegisterPeriodPaymentModal
const vatDeclarationsSettleModalId = ModalId.VatDeclarationsSettlePeriodModal
const vatDeclarationsVoidPaymentModalId = ModalId.VatDeclarationsVoidPeriodPaymentModal
const vatDeclarationsVoidSettlementModalId = ModalId.VatDeclarationsVoidPeriodSettlementModal
const vatDeclarationsChangePeriodModalId = ModalId.VatDeclarationsChangePeriodModal
const vatDeclarationsDefinePayoutModalId = ModalId.VatDeclarationsDefinePayoutModal

export const ActionModals = () => {
  const { id, periodType, periodData, currentCorrection } = useVatDeclaration()

  return (
    <>
      <VatDeclarationsExportModal
        id={vatDeclarationsExportModalId}
        vatDeclarationId={id}
        period={periodData?.periodSettled}
      />
      <VatDeclarationsSettlePeriodModal id={vatDeclarationsSettleModalId} vatDeclarationId={id} />
      <VatDeclarationsVoidPeriodSettlementModal
        id={vatDeclarationsVoidSettlementModalId}
        periodData={periodData}
        currentCorrection={currentCorrection}
        vatDeclarationId={id}
      />
      <VatDeclarationsRegisterPeriodPaymentModal id={vatDeclarationsRegisterPaymentModalId} vatDeclarationId={id} />
      <VatDeclarationsVoidPeriodPaymentModal id={vatDeclarationsVoidPaymentModalId} vatDeclarationId={id} />
      <VatDeclarationsChangePeriodModal
        id={vatDeclarationsChangePeriodModalId}
        vatDeclarationId={id}
        currentPeriodType={periodType}
        periodData={periodData}
      />
      <VatDeclarationsDefinePayoutModal id={vatDeclarationsDefinePayoutModalId} />
    </>
  )
}
